export const byFormat =
    (format: 'css' | 'js') =>
    (resource: PerformanceResourceTiming | PerformanceEntry | { name: string }) => {
        const { pathname } = new URL(resource.name);
        const regexp = new RegExp(`${format}$`);

        return regexp.test(pathname);
    };
